// extracted by mini-css-extract-plugin
export default {"fake_nav":"fake_fake_nav__gzPb9"};